export const handleDialerEligibility = async ({
  campaign,
  hasLeadAutomator,
  isLegacyAccount,
  leaveMessagePopup,
  openLeadAutomatorUpgrade,
  checkContactsPropertyAssociation,
  createDialerCampaign,
  history,
  setState,
  onEligible,
}) => {
  if (!hasLeadAutomator) {
    if (isLegacyAccount) {
      // Legacy without LA → go directly to plan upgrade, no LA modal
      leaveMessagePopup({
        title: "Upgrade Your Account",
        message: "Upgrade your account to Essentials, Pro, or Elite by clicking Upgrade Plan to continue.",
        autoWidth: false,
        yesLable: "Upgrade Plan",
        cancelLable: "Cancel",
        CancelRedirect: () => null,
        yesRedirect: () => history.push(`/accountnew/plan`),
      });
    } else {
      openLeadAutomatorUpgrade(true);
    }
    return;
  }

  setState({ isCheckingEligibility: true });

  try {
    const contactIds =
      campaign.get('contactIds')?.toJS?.() || campaign.get('contactIds');

    if (!contactIds || contactIds.length === 0) {
      setState({
        showNoEligibleLeads: true,
        isCheckingEligibility: false,
      });
      return;
    }

    const result = await checkContactsPropertyAssociation(contactIds);
    const { contactsWithProperty = [] } = result || {};

    if (contactsWithProperty.length === 0) {
      setState({
        showNoEligibleLeads: true,
        isCheckingEligibility: false,
      });
      return;
    }

    // If a callback is provided, delegate further action to the caller
    if (onEligible) {
      setState({ isCheckingEligibility: false });
      onEligible(contactIds);
      return;
    }

    const response = await createDialerCampaign({
      name: 'New Dialer Campaign',
      marketingCampaignId: campaign.get('id'),
      contactIds,
      originatingListName: campaign.get('name')
    });

    setState({ isCheckingEligibility: false }, () => {
      if (response?.id) {
        history.push(
          `/campaign/${campaign.get('id')}/dialer/${response.id}`
        );
      }
    });
  } catch (err) {
    console.error('Dialer flow failed', err);
    setState({ isCheckingEligibility: false });
  }
};
